import { ButtonAccent } from "components/Atoms/Button";
import { NewProductionModal } from "Production/New/NewProductionModal";
import React from "react";

const NewProduction = () => {
  const [isOpen, setIsOpen] = React.useState(false);

  return <>
    <ButtonAccent
      label={RESX.GeneralLabels.resxNew}
      onClick={() => { setIsOpen(true); }}
    />
    <NewProductionModal
      isOpen={isOpen}
      onClose={() => { setIsOpen(false); }}
    />
  </>;
};

export default NewProduction;